module.exports = __webpack_public_path__ + "img/1757.6422f142.gif";